module.exports = __webpack_public_path__ + "static/media/GM.c7301ccc.jpg";